import React, { useState, useEffect } from 'react';
import './Loja.css';
import fundoNovagGeracao from '../images/FUNDO_NOVAGERACAO_SEMPRE.png';
import { formatarPreco } from '../utils/formatters';
import { getImagemProduto } from '../utils/imageUtils';
import { useTracking } from '../hooks/useTracking';
import { buildApiUrl } from '../utils/api';
import { 
  Card, 
  Row, 
  Col, 
  Button, 
  Typography, 
  Space, 
  Modal, 
  InputNumber, 
  Radio, 
  Image, 
  Spin, 
  Empty,
  message,
  Tooltip
} from 'antd';
import { 
  InboxOutlined, 
  ShoppingCartOutlined, 
  PlusOutlined,
  MinusOutlined,
  GiftOutlined,
  FileTextOutlined
} from '@ant-design/icons';

const { Title, Text, Paragraph } = Typography;

// Função para adicionar cache busting nas URLs de imagem (não utilizada atualmente)
// const adicionarCacheBusting = (url) => {
//   if (!url) return url;
//   const separator = url.includes('?') ? '&' : '?';
//   return `${url}${separator}t=${Date.now()}`;
// };

const Loja = ({ user, onProdutoAdicionado }) => {
  const [produtos, setProdutos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const { trackEvent } = useTracking();
  const [quantidadesSelecionadas, setQuantidadesSelecionadas] = useState({});
  const [tamanhosSelecionados, setTamanhosSelecionados] = useState({});
  const [modalSelecao, setModalSelecao] = useState(false);
  const [produtoSelecionado, setProdutoSelecionado] = useState(null);
  const [modalQuantidade, setModalQuantidade] = useState(false);
  const [produtoQuantidade, setProdutoQuantidade] = useState(null);
  
  // Configuração do message do Ant Design
  const [messageApi, contextHolder] = message.useMessage();

  useEffect(() => {
    carregarProdutos();
    carregarCarrinho();
  }, []);

  const carregarProdutos = async () => {
    try {
      const response = await fetch(buildApiUrl('/api/produtos'));
      const data = await response.json();
      
      if (response.ok) {
        setProdutos(data.produtos);
      } else {
        setError(data.message);
      }
    } catch (error) {
      setError('Erro ao carregar produtos');
      console.error('Erro:', error);
    } finally {
      setLoading(false);
    }
  };

  const carregarCarrinho = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) return;

      const response = await fetch(buildApiUrl('/api/carrinho'), {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        // const data = await response.json(); // Variável não utilizada
        // Comentado: essas variáveis de estado foram removidas
        // setCarrinho(data.itens);
        // setQuantidadeCarrinho(data.quantidade_total);
      }
    } catch (error) {
      console.error('Erro ao carregar carrinho:', error);
    }
  };

  const alterarQuantidade = (produtoId, delta) => {
    const quantidadeAtual = quantidadesSelecionadas[produtoId] || 1;
    
    let novaQuantidade = quantidadeAtual + delta;
    
    // Limitar mínimo em 1
    if (novaQuantidade < 1) novaQuantidade = 1;
    
    setQuantidadesSelecionadas(prev => ({
      ...prev,
      [produtoId]: novaQuantidade
    }));
  };

  const definirQuantidade = (produtoId, quantidade) => {
    let novaQuantidade = parseInt(quantidade) || 1;
    
    // Limitar mínimo em 1
    if (novaQuantidade < 1) novaQuantidade = 1;
    
    setQuantidadesSelecionadas(prev => ({
      ...prev,
      [produtoId]: novaQuantidade
    }));
  };

  const selecionarTamanho = (produtoId, tamanho) => {
    setTamanhosSelecionados(prev => ({
      ...prev,
      [produtoId]: tamanho
    }));
  };

  const adicionarAoCarrinho = async (produtoId) => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        messageApi.error('Você precisa estar logado para adicionar produtos ao carrinho');
        return;
      }

      const produto = produtos.find(p => p.id === produtoId);
      
      // Se o produto tem tamanhos, abrir modal de seleção
      if (produto.tamanhos && produto.tamanhos.length > 0) {
        setProdutoSelecionado(produto);
        setModalSelecao(true);
        return;
      }

      // Se não tem tamanhos, abrir modal de quantidade
      setProdutoQuantidade(produto);
      setModalQuantidade(true);
    } catch (error) {
      console.error('Erro ao adicionar ao carrinho:', error);
      messageApi.error('Erro ao adicionar produto ao carrinho');
    }
  };

  const adicionarProdutoAoCarrinho = async (produtoId, quantidade, tamanhoSelecionado = null) => {
    try {
      const token = localStorage.getItem('token');
      const produto = produtos.find(p => p.id === produtoId);

      const dadosCarrinho = {
        produto_id: produtoId,
        quantidade: quantidade
      };

      // Adicionar tamanho apenas se o produto tiver tamanhos
      if (tamanhoSelecionado) {
        dadosCarrinho.tamanho = tamanhoSelecionado;
      }

      console.log('Enviando para o carrinho:', dadosCarrinho);
      console.log('Tamanho selecionado:', tamanhoSelecionado);
      console.log('Produto:', produto.nome);

      const response = await fetch(buildApiUrl('/api/carrinho'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(dadosCarrinho)
      });

      const data = await response.json();

      if (response.ok) {
        const mensagemTamanho = tamanhoSelecionado ? ` (Tamanho: ${tamanhoSelecionado})` : '';
        messageApi.success(`${quantidade} ${quantidade === 1 ? 'item adicionado' : 'itens adicionados'} ao carrinho${mensagemTamanho}!`);
        carregarCarrinho();
        
        // Registrar evento de adicionar ao carrinho
        trackEvent('adicionar_carrinho', `Produto: ${produto.nome}, Quantidade: ${quantidade}${tamanhoSelecionado ? `, Tamanho: ${tamanhoSelecionado}` : ''}`);
        
        // Fechar modais se estiverem abertos
        setModalSelecao(false);
        setModalQuantidade(false);
        setProdutoSelecionado(null);
        setProdutoQuantidade(null);
        
        // Chamar a função de notificação com a quantidade atualizada do carrinho
        if (onProdutoAdicionado) {
          // Recarregar o carrinho para obter a quantidade atualizada
          const carrinhoResponse = await fetch(buildApiUrl('/api/carrinho'), {
            headers: {
              'Authorization': `Bearer ${token}`
            }
          });
          
          if (carrinhoResponse.ok) {
            const carrinhoData = await carrinhoResponse.json();
            const novaQuantidade = carrinhoData.quantidade_total || 0;
            onProdutoAdicionado(novaQuantidade);
          }
        }
      } else {
        messageApi.error(data.message);
      }
    } catch (error) {
      console.error('Erro ao adicionar ao carrinho:', error);
      messageApi.error('Erro ao adicionar produto ao carrinho');
    }
  };

  const fecharModalSelecao = () => {
    setModalSelecao(false);
    setProdutoSelecionado(null);
  };

  const fecharModalQuantidade = () => {
    setModalQuantidade(false);
    setProdutoQuantidade(null);
  };

  const confirmarSelecao = async () => {
    if (!produtoSelecionado) return;
    
    const quantidade = quantidadesSelecionadas[produtoSelecionado.id] || 1;
    const tamanhoSelecionado = tamanhosSelecionados[produtoSelecionado.id];
    
    if (!tamanhoSelecionado) {
      messageApi.warning('Por favor, selecione um tamanho para este produto');
      return;
    }
    
    await adicionarProdutoAoCarrinho(produtoSelecionado.id, quantidade, tamanhoSelecionado);
  };

  const confirmarQuantidade = async () => {
    if (!produtoQuantidade) return;
    
    const quantidade = quantidadesSelecionadas[produtoQuantidade.id] || 1;
    await adicionarProdutoAoCarrinho(produtoQuantidade.id, quantidade);
  };

  if (loading) {
    return (
      <>
        {contextHolder}
        <Space direction="vertical" size="large" style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', padding: '24px', background: '#fff' }}>
          <Spin size="large" />
          <Text>Carregando produtos...</Text>
        </Space>
      </>
    );
  }

  if (error) {
    return (
      <>
        {contextHolder}
        <Space direction="vertical" size="large" style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', padding: '24px', background: '#fff' }}>
          <Empty description="Erro ao carregar produtos" />
          <Text type="danger">{error}</Text>
          <Button type="primary" onClick={carregarProdutos}>
            Tentar Novamente
          </Button>
        </Space>
      </>
    );
  }

  return (
    <>
      {contextHolder}
      
      <Space direction="vertical" size={24} style={{ width: '100%', padding: '24px', background: '#fff', minHeight: '100vh' }}>
        {/* Header com Background */}
        <Card
          bordered={false}
          bodyStyle={{
            padding: 0,
            background: `linear-gradient(135deg, rgba(62, 121, 247, 0.95) 0%, rgba(30, 90, 220, 0.95) 100%)`,
            backgroundImage: `url(${fundoNovagGeracao})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundBlendMode: 'overlay',
            borderRadius: '8px',
            minHeight: '140px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Row justify="center" align="middle" style={{ width: '100%', padding: '40px 40px' }}>
            <Col style={{ textAlign: 'center' }}>
              <Space direction="vertical" size={12}>
                <Title level={1} style={{ color: '#fff', margin: 0, fontWeight: 700, fontSize: '42px' }}>
                  Brindes Corporativos
                </Title>
                <Paragraph style={{ color: 'rgba(255, 255, 255, 0.95)', margin: 0, fontSize: '20px', fontWeight: 400 }}>
                  Descubra nossa seleção exclusiva de brindes para sua empresa
                </Paragraph>
              </Space>
            </Col>
          </Row>
        </Card>

        {/* Grid de Produtos */}
        <Row gutter={[24, 24]}>
        {/* Card de Brindes - Primeiro Item */}
        <Col xs={24} sm={12} md={8} lg={6} xl={6}>
          <Card
            hoverable
            style={{
              height: '100%',
              cursor: 'pointer',
              border: '3px solid #FFD700',
              boxShadow: '0 4px 20px rgba(255, 215, 0, 0.3)',
              overflow: 'hidden',
              display: 'flex',
              flexDirection: 'column'
            }}
            bodyStyle={{ padding: 0, flex: 1, display: 'flex', flexDirection: 'column' }}
            cover={
              <div style={{ position: 'relative', height: '280px', overflow: 'hidden' }}>
                <Image
                  src="/images/adaptado-card-de-incentivo.png"
                  alt="Brindes Disponíveis"
                  preview={{
                    mask: 'Visualizar Brindes'
                  }}
                  style={{ width: '100%', height: '280px', objectFit: 'cover', display: 'block' }}
                />
              </div>
            }
          >
            <div style={{ 
              padding: '20px 16px', 
              background: 'linear-gradient(135deg, #00796B 0%, #00695C 100%)',
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-end'
            }}>
              <Space direction="vertical" size={12} style={{ width: '100%' }}>
                <Paragraph style={{ margin: 0, color: '#fff', fontSize: '24px', lineHeight: 1.6, fontWeight: 500 }}>
                  Clique para ver os brindes exclusivos disponíveis em compras acima de valores especiais.
                </Paragraph>
                <Button
                  type="primary"
                  icon={<GiftOutlined />}
                  block
                  size="large"
                  onClick={(e) => {
                    e.stopPropagation();
                    // Trigger do preview da imagem
                    const imgElement = e.currentTarget.closest('.ant-card').querySelector('.ant-image');
                    if (imgElement) {
                      imgElement.click();
                    }
                  }}
                  style={{
                    background: '#FFD700',
                    borderColor: '#FFD700',
                    color: '#00695C',
                    borderRadius: '8px',
                    height: '48px',
                    fontSize: '16px',
                    fontWeight: '700'
                  }}
                >
                  Ver Detalhes
                </Button>
              </Space>
            </div>
          </Card>
        </Col>

        {/* Produtos */}
        {produtos.map(produto => {
          const temGuiaTamanho = produto.guia_tamanho_base64;
          
          return (
          <Col xs={24} sm={12} md={8} lg={6} xl={6} key={produto.id}>
            <Card
              hoverable
              className="produto-card-antd"
              cover={
                <>
                  <div className="produto-imagem-container" style={{ position: 'relative', height: '280px', overflow: 'hidden', background: '#f5f5f5' }}>
                    {getImagemProduto(produto) ? (
                      <Image.PreviewGroup>
                        <Image
                          src={getImagemProduto(produto)}
                          alt={produto.nome}
                          preview={{
                            mask: 'Visualizar'
                          }}
                          style={{ width: '100%', height: '280px', objectFit: 'cover', display: 'block' }}
                        />
                        {temGuiaTamanho && (
                          <Image
                            src={produto.guia_tamanho_base64}
                            alt="Guia de Tamanho"
                            style={{ 
                              position: 'absolute',
                              width: 0,
                              height: 0,
                              opacity: 0,
                              pointerEvents: 'none',
                              visibility: 'hidden'
                            }}
                          />
                        )}
                      </Image.PreviewGroup>
                    ) : (
                      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '280px' }}>
                        <InboxOutlined style={{ fontSize: '48px', color: '#d9d9d9' }} />
                      </div>
                    )}
                    
                    {/* Badge de Guia de Tamanho */}
                    {temGuiaTamanho && (
                      <>
                        {/* Desktop - Com Tooltip */}
                        <Tooltip 
                          title="Clique para visualizar guia de tamanhos"
                          placement="left"
                          color="#4a7c59"
                          overlayClassName="guia-tooltip-desktop"
                        >
                          <div 
                            className="guia-badge desktop-badge"
                            onClick={(e) => {
                              e.stopPropagation();
                              // Encontrar o segundo Image (guia de tamanho) e clicar nele
                              const guiaImage = e.currentTarget.closest('.produto-imagem-container')?.querySelectorAll('.ant-image')[1];
                              if (guiaImage) {
                                guiaImage.click();
                              }
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.transform = 'scale(1.05)';
                              e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.3)';
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.transform = 'scale(1)';
                              e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.2)';
                            }}
                          >
                            <FileTextOutlined />
                            <span>Guia</span>
                          </div>
                        </Tooltip>
                        
                        {/* Mobile - Sem Tooltip */}
                        <div 
                          className="guia-badge mobile-badge"
                          onClick={(e) => {
                            e.stopPropagation();
                            // Encontrar o segundo Image (guia de tamanho) e clicar nele
                            const guiaImage = e.currentTarget.closest('.produto-imagem-container')?.querySelectorAll('.ant-image')[1];
                            if (guiaImage) {
                              guiaImage.click();
                            }
                          }}
                        >
                          <FileTextOutlined />
                          <span>Guia</span>
                        </div>
                      </>
                    )}
                  </div>
                </>
              }
            >
              <Card.Meta
                title={
                  <Title level={4} style={{ marginBottom: '8px', fontSize: '18px', color: '#4a7c59' }}>
                    {produto.nome}
                  </Title>
                }
                description={
                  <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                    <Paragraph
                      ellipsis={{ rows: 3, expandable: false }}
                      style={{ marginBottom: '12px', color: '#666', fontSize: '14px' }}
                    >
                      {produto.descricao}
                    </Paragraph>
                    <div style={{ marginTop: 'auto' }}>
                      <div style={{ marginBottom: '16px' }}>
                        <Text strong style={{ fontSize: '24px', color: '#4a7c59' }}>
                          {formatarPreco(produto.preco)}
                        </Text>
                      </div>
                      <Button
                        type="primary"
                        icon={<ShoppingCartOutlined />}
                        onClick={() => adicionarAoCarrinho(produto.id)}
                        block
                        size="large"
                        style={{
                          background: 'linear-gradient(135deg, #4a7c59 0%, #2d5f3f 100%)',
                          border: 'none',
                          borderRadius: '8px',
                          height: '44px',
                          fontSize: '15px',
                          fontWeight: '600'
                        }}
                      >
                        Adicionar ao Carrinho
                      </Button>
                    </div>
                  </div>
                }
              />
            </Card>
          </Col>
        );
        })}
        </Row>

        {produtos.length === 0 && (
          <Empty
            description="Nenhum produto disponível no momento"
            style={{ marginTop: '60px' }}
          >
            <Text type="secondary">Aguarde novos produtos serem adicionados.</Text>
          </Empty>
        )}
      </Space>

      {/* Modal de Seleção de Tamanho */}
      <Modal
        title="Selecionar Tamanho e Quantidade"
        open={modalSelecao}
        onCancel={fecharModalSelecao}
        width={700}
        centered
        footer={[
          <Button key="cancelar" onClick={fecharModalSelecao}>
            Cancelar
          </Button>,
          <Button
            key="confirmar"
            type="primary"
            icon={<ShoppingCartOutlined />}
            onClick={confirmarSelecao}
            disabled={produtoSelecionado && !tamanhosSelecionados[produtoSelecionado.id]}
            style={{
              background: 'linear-gradient(135deg, #4a7c59 0%, #2d5f3f 100%)',
              border: 'none'
            }}
          >
            Adicionar ao Carrinho
          </Button>,
        ]}
      >
        {produtoSelecionado && (
          <Space direction="vertical" size="large" style={{ width: '100%' }}>
            {/* Informações do Produto */}
            <Row gutter={16}>
              <Col span={8}>
                {getImagemProduto(produtoSelecionado) ? (
                  <Image
                    src={getImagemProduto(produtoSelecionado)}
                    alt={produtoSelecionado.nome}
                    style={{ width: '100%', borderRadius: '8px' }}
                  />
                ) : (
                  <div style={{ 
                    width: '100%', 
                    height: '150px', 
                    background: '#f5f5f5', 
                    borderRadius: '8px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}>
                    <InboxOutlined style={{ fontSize: '48px', color: '#d9d9d9' }} />
                  </div>
                )}
              </Col>
              <Col span={16}>
                <Space direction="vertical" size="small" style={{ width: '100%' }}>
                  <Title level={4} style={{ margin: 0, color: '#4a7c59' }}>
                    {produtoSelecionado.nome}
                  </Title>
                  <Paragraph 
                    ellipsis={{ rows: 3 }}
                    style={{ marginBottom: '8px', color: '#666' }}
                  >
                    {produtoSelecionado.descricao}
                  </Paragraph>
                  <Text strong style={{ fontSize: '22px', color: '#4a7c59' }}>
                    {formatarPreco(produtoSelecionado.preco)}
                  </Text>
                </Space>
              </Col>
            </Row>

            {/* Seleção de Tamanho */}
            <div>
              <Text strong style={{ display: 'block', marginBottom: '12px', fontSize: '15px' }}>
                Tamanho:
              </Text>
              <Radio.Group
                value={tamanhosSelecionados[produtoSelecionado.id]}
                onChange={(e) => selecionarTamanho(produtoSelecionado.id, e.target.value)}
                buttonStyle="solid"
                style={{ width: '100%' }}
              >
                <Space wrap>
                  {produtoSelecionado.tamanhos?.map((tamanho, index) => (
                    <Radio.Button 
                      key={index} 
                      value={tamanho}
                      style={{
                        minWidth: '60px',
                        textAlign: 'center',
                        borderRadius: '6px',
                        height: '40px',
                        lineHeight: '40px'
                      }}
                    >
                      {tamanho}
                    </Radio.Button>
                  ))}
                </Space>
              </Radio.Group>
              {tamanhosSelecionados[produtoSelecionado.id] && (
                <Text type="success" style={{ display: 'block', marginTop: '8px', fontSize: '13px' }}>
                  ✓ Tamanho selecionado: <strong>{tamanhosSelecionados[produtoSelecionado.id]}</strong>
                </Text>
              )}
            </div>

            {/* Quantidade */}
            <div>
              <Text strong style={{ display: 'block', marginBottom: '12px', fontSize: '15px' }}>
                Quantidade:
              </Text>
              <Space>
                <Button
                  icon={<MinusOutlined />}
                  onClick={() => alterarQuantidade(produtoSelecionado.id, -1)}
                  disabled={(quantidadesSelecionadas[produtoSelecionado.id] || 1) <= 1}
                />
                <InputNumber
                  min={1}
                  value={quantidadesSelecionadas[produtoSelecionado.id] || 1}
                  onChange={(value) => definirQuantidade(produtoSelecionado.id, value)}
                  style={{ width: '80px' }}
                />
                <Button
                  icon={<PlusOutlined />}
                  onClick={() => alterarQuantidade(produtoSelecionado.id, 1)}
                />
              </Space>
            </div>
          </Space>
        )}
      </Modal>

      {/* Modal de Seleção de Quantidade */}
      <Modal
        title="Selecionar Quantidade"
        open={modalQuantidade}
        onCancel={fecharModalQuantidade}
        width={700}
        centered
        footer={[
          <Button key="cancelar" onClick={fecharModalQuantidade}>
            Cancelar
          </Button>,
          <Button
            key="confirmar"
            type="primary"
            icon={<ShoppingCartOutlined />}
            onClick={confirmarQuantidade}
            style={{
              background: 'linear-gradient(135deg, #4a7c59 0%, #2d5f3f 100%)',
              border: 'none'
            }}
          >
            Adicionar ao Carrinho
          </Button>,
        ]}
      >
        {produtoQuantidade && (
          <Space direction="vertical" size="large" style={{ width: '100%' }}>
            {/* Informações do Produto */}
            <Row gutter={16}>
              <Col span={8}>
                {getImagemProduto(produtoQuantidade) ? (
                  <Image
                    src={getImagemProduto(produtoQuantidade)}
                    alt={produtoQuantidade.nome}
                    style={{ width: '100%', borderRadius: '8px' }}
                  />
                ) : (
                  <div style={{ 
                    width: '100%', 
                    height: '150px', 
                    background: '#f5f5f5', 
                    borderRadius: '8px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}>
                    <InboxOutlined style={{ fontSize: '48px', color: '#d9d9d9' }} />
                  </div>
                )}
              </Col>
              <Col span={16}>
                <Space direction="vertical" size="small" style={{ width: '100%' }}>
                  <Title level={4} style={{ margin: 0, color: '#4a7c59' }}>
                    {produtoQuantidade.nome}
                  </Title>
                  <Paragraph 
                    ellipsis={{ rows: 3 }}
                    style={{ marginBottom: '8px', color: '#666' }}
                  >
                    {produtoQuantidade.descricao}
                  </Paragraph>
                  <Text strong style={{ fontSize: '22px', color: '#4a7c59' }}>
                    {formatarPreco(produtoQuantidade.preco)}
                  </Text>
                </Space>
              </Col>
            </Row>

            {/* Quantidade */}
            <div>
              <Text strong style={{ display: 'block', marginBottom: '12px', fontSize: '15px' }}>
                Quantidade:
              </Text>
              <Space>
                <Button
                  icon={<MinusOutlined />}
                  onClick={() => alterarQuantidade(produtoQuantidade.id, -1)}
                  disabled={(quantidadesSelecionadas[produtoQuantidade.id] || 1) <= 1}
                />
                <InputNumber
                  min={1}
                  value={quantidadesSelecionadas[produtoQuantidade.id] || 1}
                  onChange={(value) => definirQuantidade(produtoQuantidade.id, value)}
                  style={{ width: '80px' }}
                />
                <Button
                  icon={<PlusOutlined />}
                  onClick={() => alterarQuantidade(produtoQuantidade.id, 1)}
                />
              </Space>
            </div>
          </Space>
        )}
      </Modal>
    </>
  );
};

export default Loja; 